<script setup lang="ts">
import { Label, type LabelProps } from "reka-ui";
import { useDelegatedProps, type ClassProps } from "../../lib/base-props";
import { cn } from "../../lib/utils";

interface Props extends LabelProps, ClassProps {}

const props = withDefaults(defineProps<Props>(), { as: "label" });

const delegatedProps = useDelegatedProps(props);
</script>

<template>
	<Label
		v-bind="delegatedProps"
		:class="cn('fieldset-label grow text-xs text-inherit', props.class)"
	>
		<slot />
	</Label>
</template>
